module.exports = __webpack_public_path__ + "f39df99c8d47a8ea01d032d58a8d3473.svg";